import { Box, Tab, Tabs } from '@mui/material';
import { TABLE_HEADER_BACKGROUND_COLOR } from '../../../constants/colors';
import { CouponEnum } from '../../../enums/couponEnum';
import { useTranslation } from 'react-i18next';

interface Props {
  value: CouponEnum;
  onChange: (newValue: CouponEnum) => void;
}

const TabPanelCouponPage = ({ value, onChange }: Props) => {
  const { t } = useTranslation('global');

  return (
    <Box sx={{ width: '100%', backgroundColor: TABLE_HEADER_BACKGROUND_COLOR }}>
      <Box sx={{ borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={(e: any, newValue: CouponEnum) => {
            onChange(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab
            label={t('coupon_page.Amount')}
            value={CouponEnum.AMOUNT}
            sx={{ textTransform: 'none' }}
          />
          <Tab
            label={t('coupon_page.Percent')}
            value={CouponEnum.PERCENT}
            sx={{ textTransform: 'none' }}
          />
          <Tab
            label={t('coupon_page.Delivery free')}
            value={CouponEnum.DELIVERY_FREE}
            sx={{ textTransform: 'none' }}
          />
          <Tab
            label={t('coupon_page.DeliveryAmount')}
            value={CouponEnum.DELIVERY_FEE_AMOUNT}
            sx={{ textTransform: 'none' }}
          />
          <Tab
            label={t('coupon_page.DeliveryPercent')}
            value={CouponEnum.DELIVERY_FEE_PERCENT}
            sx={{ textTransform: 'none' }}
          />
        </Tabs>
      </Box>
    </Box>
  );
};
export default TabPanelCouponPage;
